export const styles = (theme: any) => {
    return {
        root: {
            //marginRight: '5px'

        },
        searchButtonContainer: {
            display: 'flex',
            justifyContent:"flex-end",
            alignItems: 'center',
            [theme.breakpoints.only('xs')]: {
                justifyContent: 'center',
            }
        },
        searchButton: {
            // [theme.breakpoints.only('xs')]: {

            // }
        }
    }
}